import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Fade triggerOnce>
      <div className="container-fluid bg-call text-light footer my-6 mb-0 py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Office Address</h4>
            <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>Abudhabi,Uae</p>
            <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>+971 563252389</p>
            <p className="mb-2"><i className="fa fa-envelope me-3"></i>gm@newgalaxyy.com</p>
            <div className="d-flex pt-2">
              <a className="btn btn-square btn-outline-light rounded-circle me-1" href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a className="btn btn-square btn-outline-light rounded-circle me-1" href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a className="btn btn-square btn-outline-light rounded-circle me-1" href="https://youtube.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              <a className="btn btn-square btn-outline-light rounded-circle me-0" href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Quick Links</h4>
            <Link to="/about" className="btn btn-link">About Us</Link>
            <Link to="/contact" className="btn btn-link">Contact Us</Link>
            <Link to="/service" className="btn btn-link">Our Services</Link>
            <a className="btn btn-link" href="/">Terms & Condition</a>
            <a className="btn btn-link" href="/contact">Support</a>
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Usefull Links</h4>
            <Link to="/" className="btn btn-link">Career</Link>
            <Link to="/" className="btn btn-link">FAQ</Link>
            <Link to="/" className="btn btn-link">Offers</Link>
           
          </div>
          <div className="col-lg-3 col-md-6">
            <h4 className="text-light mb-4">Photo Gallery</h4>
            <div className="row g-2">
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img50.jpg" alt="Gallery" />
              </div>
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img6.jpg" alt="Gallery" />
              </div>
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img15.jpg" alt="Gallery" />
              </div>
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img12.jpg" alt="Gallery" />
              </div>
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img24.jpg" alt="Gallery" />
              </div>
              <div className="col-4">
                <img className="img-fluid bg-light rounded p-1" src="/img/img22.jpg" alt="Gallery" />
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </Fade>
  );
};

export default Footer;






